import { render, staticRenderFns } from "./add_shoplist_js.vue?vue&type=template&id=38104789&scoped=true&"
import script from "./add_shoplist_js.vue?vue&type=script&lang=js&"
export * from "./add_shoplist_js.vue?vue&type=script&lang=js&"
import style0 from "./add_shoplist_js.vue?vue&type=style&index=0&id=38104789&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38104789",
  null
  
)

export default component.exports